// extracted by mini-css-extract-plugin
export var locationCard = "_du-0";